import type { SVGProps } from "react";
import * as React from "react";

export const AddIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 10"
    className="fill-current"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.504}
      d="M4.657 1.256v7.3m3.65-3.65h-7.3"
    />
  </svg>
);
